import { sendMessageToApp } from '@libs/client'
import BackBtnLogo from '@ui/components/checkout/BackBtnLogo'
import { NextPage } from 'next'
import css from 'styled-jsx/css'

export const getServerSideProps = () => {
  return {
    props: {}
  }
}

const privacyPolicyPage: NextPage = () => {
  const handleBack = () => {
    sendMessageToApp({
      type: 'BACK'
    })
  }

  return (
    <>
      <div className="static-page">
        <style jsx global>
          {globalStyle}
        </style>
        <div className="wrapper">
          <div className="policy__header">
            <button className="back-btn" onClick={handleBack}>
              <BackBtnLogo />
            </button>

            <p className="policy__title">Privacy Policy</p>
            <div className="tracking__divider " />
          </div>
          <div className="page__content">
            <div className="static-content">
              <div className="content__items">
                <div className="item">
                  <div className="item__contents">
                    <p className="item__content">
                      We at <span className="shop__name">ShopHelp</span> know you care about how
                      your personal information is used and shared, and we take your privacy
                      seriously.
                    </p>
                    <p className="item__content">
                      Please read the following to learn more about our Privacy Policy. By using or
                      accessing our services, including this site, in any manner, you acknowledge
                      that you accept the practices and policies outlined in this Privacy Policy,
                      and you hereby consent that we will collect, use, and share your information
                      in the following ways.
                    </p>
                  </div>
                </div>
                <div className="item">
                  <h1 className="item__title">HOW DO WE COLLECT YOUR INFORMATION?</h1>
                  <div className="item__contents">
                    <p className="item__content">
                      This Data Protection Notice (“Notice”) outlines the basis on which we collect,
                      use, disclose, or otherwise process the personal data of our customers, in
                      compliance with the General Data Protection Regulation (GDPR).
                    </p>
                    <p className="item__content">
                      This Notice applies to personal data in our possession or under our control,
                      including personal data in the possession of organizations which we have
                      engaged to collect, use, disclose or process personal data for our purposes.
                    </p>
                    <p className="item__content">
                      When you purchase something from our store, as part of the buying and selling
                      process, we collect the personal information you give us such as your name,
                      address, email address and phone number.
                    </p>
                    <p className="item__content">
                      When you browse our store, we also automatically receive your computer’s
                      internet protocol (IP) address in order to provide us with information that
                      helps us learn about your browser and operating system.
                    </p>
                  </div>
                </div>

                <div className="item">
                  <h1 className="item__title">HOW DO WE USE YOUR INFORMATION?</h1>
                  <div className="item__contents">
                    <p className="item__content">
                      If you have visited or made a purchase from{' '}
                      <span className="shop__name">ShopHelp</span>. we use information you provide
                      about yourself like your name, billing address, shipping address, email
                      address, the phone number to provide you and our partners’ store with our
                      services to provide service to you:
                    </p>
                    <ul className="item__content">
                      <li className="item__disc">
                        Provide the Service and operate and improve the Service and our business;
                      </li>
                      <li className="item__disc">
                        Establish and maintain your user profile on the Service;
                      </li>
                      <li className="item__disc">
                        Communicate with you about the Service, including by sending announcements,
                        order updates, security alerts, and support and administrative messages;
                      </li>
                      <li className="item__disc">
                        Understand your needs and interests, and personalize your experience with
                        the Service and our communications;
                      </li>
                      <li className="item__disc">
                        Provide support for the Service, and respond to your requests, questions,
                        and feedback.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="item">
                  <h1 className="item__title">CONSENT</h1>
                  <div className="item__contents">
                    <h1 className="item__title">
                      <em>How do you get my consent? (opt-in)</em>
                    </h1>
                    <p className="item__content">
                      When you provide us with personal information to complete a transaction,
                      verify your credit card, place an order, arrange for a delivery or return a
                      purchase, we imply that you consent to our collecting it and using it for that
                      specific reason only.
                    </p>
                    <p className="item__content">
                      If we ask for your personal information for a secondary reason, like
                      marketing, we will either ask you directly for your expressed consent or
                      provide you with an opportunity to say no.
                    </p>
                    <h1 className="item__title">
                      <em>How do I withdraw my consent? (opt-out)</em>
                    </h1>

                    <p className="item__content">
                      If after you opt-in, you change your mind, you may withdraw your consent for
                      us to contact you, for the continued collection, use, or disclosure of your
                      personal information, at any time.
                    </p>
                    <p className="item__content">
                      There are several methods by which you can exercise your opt-out choices for
                      the promotional materials from us and from our Merchant Partners:
                    </p>
                    <ul className="item__content">
                      <li className="item__disc">
                        By writing an email to support@shophelp.io using the contact information
                        provided below.
                      </li>
                    </ul>
                    <p className="item__content">
                      Each of these opt-out choices is subject to the exceptions described further
                      below.
                    </p>
                    <p className="item__content">
                      Please keep in mind that any opt-out choices you make will not apply in
                      situations where (a) you either have made, simultaneously make, or later make
                      a specific request for information from us, (b) we use your personal
                      information for either “Operational Uses” or “Fulfillment Uses” (as
                      described), (c) we share your personal information under the provisions above
                      with respect to “Companies That Facilitate Communications and Transactions
                      With You,” “Independent Shop Consultants” or “Disclosures Required By Law and
                      Disclosures to Help Protect the Security and Safety of Our Sites and Others.”
                    </p>
                    <p className="item__content">
                      Finally, if you do not exercise your opt-out choices upon registration or
                      initial log-in at our Site, it may take up to thirty (30) days for your
                      opt-out choices to become effective. As our systems require time to update,
                      promotional mailings using personal information shared before you opt-out may
                      already be in process. Thus, you might continue to receive promotional
                      materials from us based upon the personal information you have provided under
                      this Privacy Policy for up to thirty (30) days. For similar reasons, your
                      personal information might continue to be shared with third parties for
                      promotional purposes for up to thirty (30) days.
                    </p>
                  </div>
                </div>

                <div className="item">
                  <h1 className="item__title">DISCLOSURE</h1>
                  <div className="item__contents">
                    <p className="item__content">
                      We may disclose your personal information if we are required by law to do so
                      or if you violate our Terms of Service.
                    </p>
                  </div>
                </div>

                <div className="item">
                  <h1 className="item__title">ACCURACY OF PERSONAL DATA</h1>
                  <div className="item__contents">
                    <p className="item__content">
                      We will make a reasonable effort to ensure that personal data collected by us
                      or on our behalf is accurate and complete.
                    </p>
                  </div>
                </div>

                <div className="item">
                  <h1 className="item__title">SECURITY AND PROTECTION OF PERSONAL DATA</h1>
                  <div className="item__contents">
                    <p className="item__content">
                      Ensuring the security of your personal information is a top priority for us.
                      While no method of data transmission over the Internet or electronic storage
                      is completely secure, we are committed to implementing the best commercially
                      available security measures. We adhere to the Payment Card Industry Data
                      Security Standard (PCI DSS) Level 1 for the highest security in payment
                      processing. Additionally, we are committed to complying with the General Data
                      Protection Regulation (GDPR) to ensure robust protection of data privacy for
                      all our customers
                    </p>
                    <h1 className="item__title">
                      <em>Your information belongs to you</em>
                    </h1>
                    <p className="item__content">
                      We carefully analyze what types of information we need to provide our
                      services, and we try to limit the information we collect to only what we
                      really need. Where possible, we delete or anonymize this information when we
                      no longer need it. When building and improving our products, our engineers
                      work closely with our privacy and security teams to build with privacy in
                      mind. In all of this work, our guiding principle is that your information
                      belongs to you, and we aim to only use your information to your benefit.
                    </p>
                    <h1 className="item__title">
                      <em>We protect your information from others</em>
                    </h1>

                    <p className="item__content">
                      If a third party requests your personal information, we will refuse to share
                      it unless you give us permission or we are legally required. When we are
                      legally required to share your personal information, we will tell you in
                      advance, unless we are legally forbidden.
                    </p>
                  </div>
                </div>

                <div className="item">
                  <h1 className="item__title">RETENTION OF PERSONAL DATA</h1>
                  <div className="item__contents">
                    <p className="item__content">
                      We may retain your personal data for as long as it is necessary to fulfill the
                      purpose for which it was collected, or as required or permitted by applicable
                      laws. We will cease to retain your personal data, or remove the means by which
                      the data can be associated with you, as soon as it is reasonable to assume
                      that such retention no longer serves the purpose for which the personal data
                      was collected, and is no longer necessary for legal or business purposes.
                    </p>
                  </div>
                </div>

                <div className="item">
                  <h1 className="item__title">
                    TRANSFER OF PERSONAL DATA OUTSIDE OF THE UNITED STATES
                  </h1>
                  <div className="item__contents">
                    <p className="item__content">
                      We will ensure that any transfers of personal data outside of the United
                      States comply with the General Data Protection Regulation (GDPR), thus
                      upholding a standard of protection for personal data that is comparable to
                      that provided under GDPR.
                    </p>
                    <p className="item__content">
                      We may disclose personal data to our global offices, where it is necessary (i)
                      to meet the purpose for which you have submitted the information; or (ii) to
                      enable you to be provided with information at a later date which may be of
                      relevance and interest to you based on the nature and purpose of your
                      voluntary requests. We may also transfer all data in our possession to a
                      successor-in-interest to our business or assets.
                    </p>
                  </div>
                </div>

                <div className="item">
                  <h1 className="item__title">SELLESS</h1>
                  <div className="item__contents">
                    <p className="item__content">
                      Our store is hosted by SELLESS service which is an e-commerce platform that
                      allows us to sell products and provide services to you.
                    </p>
                    <p className="item__content">
                      Your data is stored through SELLESS’s data storage, databases and the
                      platform. They store your data on a secure server behind a firewall.
                    </p>
                    <p className="item__content">
                      Payment Security: When you choose a direct payment gateway, your credit card
                      data is encrypted in accordance with the Payment Card Industry Data Security
                      Standard <strong>(PCI DSS) Level 1</strong>. We retain your purchase
                      transaction data only as long as necessary to complete your transaction, after
                      which it is securely deleted.
                    </p>
                    <p className="item__content">
                      All our payment gateways adhere to PCI DSS standards, ensuring that your
                      credit card information is handled securely. We also ensure that our data
                      handling practices are in line with the{' '}
                      <strong>General Data Protection Regulation (GDPR)</strong> to safeguard your
                      personal data comprehensively.
                    </p>
                  </div>
                </div>

                <div className="item">
                  <h1 className="item__title">THIRD-PARTY SERVICES</h1>
                  <div className="item__contents">
                    <p className="item__content">
                      In general, the third-party providers used by us will only collect, use and
                      disclose your information to the extent necessary to allow them to perform the
                      services they provide to us.
                    </p>
                    <p className="item__content">
                      However, certain third-party service providers, such as payment gateways and
                      other payment transaction processors, have their own privacy policies with
                      respect to the information we are required to provide to them for your
                      purchaserelated transactions.
                    </p>
                    <p className="item__content">
                      For these providers, we recommend that you read their privacy policies so you
                      can understand the manner in which your personal information will be handled
                      by these providers.
                    </p>
                    <p className="item__content">
                      In particular, remember that certain providers may be located in or have
                      facilities that are located a different jurisdiction than either you or us. So
                      if you elect to proceed with a transaction that involves the services of a
                      third-party service provider, then your information may become subject to the
                      laws of the jurisdiction(s) in which that service provider or its facilities
                      are located.
                    </p>
                    <p className="item__content">
                      As an example, if you are located in Canada and your transaction is processed
                      by a payment gateway located in the United States, then your personal
                      information used in completing that transaction may be subject to disclosure
                      under United States legislation, including the Patriot Act.
                    </p>
                    <p className="item__content">
                      Once you leave our store’s website or are redirected to a third-party website
                      or application, you are no longer governed by this Privacy Policy or our
                      website’s Terms of Service.
                    </p>
                    <p className="item__content">
                      <em>Links:</em>
                      <br />
                      When you click on links on our store, they may direct you away from our site.
                      We are not responsible for the privacy practices of other sites and encourage
                      you to read their privacy statements.
                    </p>
                  </div>
                </div>
                <div className="item">
                  <h1 className="item__title">SECURITY</h1>
                  <div className="item__contents">
                    <p className="item__content">
                      To protect your personal information, we take reasonable precautions and
                      follow industry best practices to make sure it is not inappropriately lost,
                      misused, accessed, disclosed, altered or destroyed.
                    </p>
                    <p className="item__content">
                      If you provide us with your credit card information, the information is
                      encrypted using secure socket layer technology (SSL) and stored with a AES-256
                      encryption. Although no method of transmission over the Internet or electronic
                      storage is 100% secure, we follow all PCI-DSS requirements and implement
                      additional generally accepted industry standards.
                    </p>
                  </div>
                </div>
                <div className="item">
                  <h1 className="item__title">COOKIES</h1>
                  <div className="item__contents">
                    <p className="item__content">
                      Here is a list of cookies that we use. We’ve listed them here so you that you
                      can choose if you want to opt-out of cookies or not.
                    </p>
                    <ul className="item__content">
                      <li className="item__disc">
                        _version_: Marks the website version that we are serving users, to maintain
                        a consistent website for future visits.
                      </li>
                      <li className="item__disc">
                        pversion_{'{'}slug{'}'}: Marks the content version that we are serving
                        users, to ensure consistent content for future visits.
                      </li>
                      <li className="item__disc">
                        current_config: Stores the current content version configuration to serve
                        users when they revisit the site.
                      </li>
                      <li className="item__disc">
                        is_clear_cart: A temporary cookie sent by the server to instruct the client
                        {"'"}s browser to clear the shopping cart if the cached cart is outdated
                        (e.g., if a product is no longer being sold on the site).
                      </li>
                      <li className="item__disc">
                        _time_visit_: Records the most recent time a user visited the site (in
                        timestamp numeric format); the page may offer different promotions to
                        maximize user value.
                      </li>
                      <li className="item__disc">
                        _show_message_: Marks the state of the promotion popup message to avoid
                        annoying the user on subsequent visits.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="item">
                  <h1 className="item__title">AGE OF CONSENT</h1>
                  <div className="item__contents">
                    <p className="item__content">
                      By using this site, you represent that you are at least the age of majority in
                      your state or province of residence, or that you are the age of majority in
                      your state or province of residence and you have given us your consent to
                      allow any of your minor dependents to use this site.
                    </p>
                  </div>
                </div>

                <div className="item">
                  <h1 className="item__title">CHANGES TO THIS PRIVACY POLICY</h1>
                  <div className="item__contents">
                    <p className="item__content">
                      We reserve the right to modify this privacy policy at any time, so please
                      review it frequently. Changes and clarifications will take effect immediately
                      upon their posting on the website. If we make material changes to this policy,
                      we will notify you here that it has been updated, so that you are aware of
                      what information we collect, how we use it, and under what circumstances, if
                      any, we use and/or disclose it.
                    </p>
                    <p className="item__content">
                      If our store is acquired or merged with another company, your information may
                      be transferred to the new owners so that we may continue to sell products to
                      you.
                    </p>
                  </div>
                </div>

                <div className="item">
                  <h1 className="item__title">QUESTIONS AND CONTACT INFORMATION</h1>
                  <div className="item__contents">
                    <p className="item__content">
                      If you would like to: access, correct, amend or delete any personal
                      information we have about you, register a complaint, or simply want more
                      information contact our Privacy Compliance Officer at +1 (877) 778-8353
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const globalStyle = css.global`
  .static-page {
    .policy__header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 8px 0px;
      position: relative;
      height: 46px;
      margin-bottom: 10px;
    }

    .policy__title {
      font-weight: 600;
      font-size: 18px;
    }

    .back-btn {
      border: none;
      background: transparent;
      outline: none;
      display: flex;
      position: absolute;
      left: 0;
      padding: 0;
      margin-left: 12px;
    }

    .tracking__divider {
      height: 1px;
      background-color: #e8e8e8;
      position: absolute;
      left: 0;
      right: 0;
      top: 46px;
    }
    .page__content {
      margin: auto;
      max-width: 650px;
    }

    .static-content {
      margin: 12px;
      .item__title {
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 80px;
      }

      .item {
        margin-bottom: 40px;

        &__title {
          font-weight: bold;
          margin-bottom: 20px;
        }

        &__content {
          margin-bottom: 20px;
        }

        &__disc {
          list-style-type: disc;
          list-style-position: inside;
          display: list-item;
        }
      }

      a {
        color: #2d9cdb;
        text-decoration: underline;

        &.is-phone {
          color: var(--text);
          text-decoration: unset;
        }
      }

      ol {
        list-style-type: inherit;
      }

      .shop__name {
        color: #2d9cdb;
      }
    }
  }
`

export default privacyPolicyPage
